export const isV2TokenExpired = (v2Token) => {
    return !!v2Token && (v2Token?.expiresAt ?? 0) < new Date().getTime() / 1000;
};
